import { memo, useCallback, useEffect, useState, useRef } from "react";
import {
    Autocomplete, Box, Button, DialogActions, Fade, Grid, InputAdornment, List, ListItem, ListItemIcon, ListSubheader,
    Menu, MenuItem, Modal, TextField, Typography
} from '@mui/material';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import hashFill from '@iconify/icons-eva/hash-fill';
import { Icon } from '@iconify/react';
import SvgIcon from "@mui/material/SvgIcon";
import { styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import { ReactComponent as VisualizeIcon } from "../../../assets/icons/icon-visualize.svg";
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down-2.svg";
import { ReactComponent as InputSearchIcon } from "../../../assets/icons/icon-feather-search.svg";
import { ReactComponent as MoreIcon } from "../../../assets/icons/icon-more.svg";
import { ReactComponent as FieldCloseIcon } from "../../../assets/icons/icon_close.svg";
import { ReactComponent as FieldTickIcon } from "../../../assets/icons/icon-tick-dark.svg";
import ReportGraphTypes from "../ReportGraphTypes";
import { updateQuery } from "../../../utils/Reusables";
import { useSelector, useDispatch } from "react-redux";
import { reportActions } from "../../../redux/reducers/report/reportReducer";

const RootStyle = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
        flexShrink: 0,
    },
}))
const useStyles = makeStyles((theme) => ({
    fieldMenu: {
        boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
    },
    autoCompleteInp: {
        fontWeight: 'normal'
    },
    fieldBtn: {
        position: 'absolute',
        right: '5px',
        bottom: '0px',
        cursor: 'pointer',
        minWidth: 'auto !important',
    },
    reportFieldList: {
        width: '100%',
        backgroundColor: '#fff',
        maxHeight: '350px',
        minHeight: '350px',
        marginBottom: '1rem',
        overflow: 'auto',
        marginTop: '5px',
        borderRadius: '4px',
    },
    bgWhite: {
        backgroundColor: '#fff',
        borderRadius: '4px',
    },
    grey_bg: {
        backgroundColor: '#f1f1f1',
    },
    formInput: {
        paddingLeft: 0,
        '&::placeholder': {
            paddingLeft: '-10px',
        }
    },
    searchFieldListItem: {
        paddingTop: '0.6rem',
        paddingBottom: '0.6rem',
        '&:hover': {
            background: "#f1f1f1",
            zIndex: 9,
            "& $listItemDescription": {
                visibility: 'visible'
            },
            "& $searchFieldListMoreIcon": {
                visibility: 'visible'
            }
        },

    },
    listItemDescription: {
        fontSize: '12px',
        lineHeight: '24px',
        color: '#202124',
    },
    searchFieldListMoreIcon: {
        width: '12px',
        height: '12px',
        visibility: 'hidden',
        '&:hover': {
            visibility: 'visible'
        }
    }

}));
const ParseSvgIcon = ({ component }) => <SvgIcon component={component} width={100} height={100} />

const ReportVisualizeTab = ({dataSetList,handleConfirmDataSetChange,selectedDataset,query,setQuery}) => {
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = useState(null)
    const [selectedMeasure,setSelectedMeasure] = useState(null)
    const [searchMeasure,setSearchMeasure] = useState('')
    const [datasetOpenStatus, setDatasetOpenStatus] = useState(true);
    const datasetRef = useRef(null);
    const reportDetails = useSelector(state => state.reportDetails)
    const dispatch = useDispatch()

    const handleSearchMeasure = useCallback((event) => {
        //console.log(event)
        setSearchMeasure(event.target.value.toLowerCase())
    })

    const clickMeasureListHandler = useCallback((measure) => {
        //console.log(measure)
        if(measure.dataSetType === 'MEASURE'){
            handleQueryFields(measure,'measures','updateMeasures')            
        }else{
            handleQueryFields(measure,'dimensions','updateDimensions')
        }
    })

    const handleQueryFields = useCallback((measure,fieldType,fnName) => {
        ///console.log(measure)
        let oldQuery = JSON.parse(JSON.stringify(query))
        let index = oldQuery[fieldType] ? oldQuery[fieldType].indexOf(measure.title): -1
        //let orderIndex  = oldQuery.order ? oldQuery.order.map(obj => obj[0]).indexOf(measure.title):-1
        if(!oldQuery['order']){
            oldQuery['order'] = []
        }
        if( index > -1){
            oldQuery[fieldType].splice(index, 1)
            //oldQuery.order.splice(orderIndex, 1)
            dispatch(reportActions.removeField({fieldName:measure.title}))
        }else{
            if( oldQuery[fieldType]){
                oldQuery[fieldType].push(measure.title)
            }else{
                oldQuery[fieldType] = []
                oldQuery[fieldType].push(measure.title)
            }
            /* const orderField = measure.title
            const order = fieldType == 'measures' ? 'desc' : 'asc';
            oldQuery.order.push([orderField, order]) */
            
            dispatch(reportActions.addField({field:{
                displayName: measure.displayName,
                format:'',
                concated:false,
                concatFlag:false,
                width:'',
                align:'left',
                concatWith:[],
                delimiter: ',',
                truncate: false,
                group:false,
                truncateWith:',',
                truncateCount:5,
                name:measure.name,
                member:measure.title,
                type:measure.type,
                axis:fieldType == 'measures' ? 'y':'x',
                hidden:false,
                fieldType: measure.dataSetType
            }}))
            
        }       
        
        updateQuery(oldQuery,{offset:0,order:oldQuery.order,[fieldType]:oldQuery[fieldType]},setQuery)
    })

    const onClickMoreMenu = useCallback((event, measure) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
        setSelectedMeasure(measure)
    })

    const onMoreMenuClose = useCallback((e) => {
        e.stopPropagation()
        setAnchorEl(null)
    })

    const handleDataSetOpenStatus = () => {
        //datasetRef?.current?.classList.add("dataset-opened");
        setDatasetOpenStatus(true);
    }

    const handleDataSetCloseStatus = () => {
        //datasetRef?.current?.classList.remove("dataset-opened");
        setDatasetOpenStatus(false);
    }

    // console.log(query,selectedDataset)

    return <RootStyle>
        <div>
            <Box width="100%" height="100%">
                <Box className={`re-edit-settings-dataset-input ` + (datasetOpenStatus ? ` dataset-opened ` : ``)} ref={datasetRef}>
                    <Typography className="re-form-autocomplete-label" variant="subtitle1" display="block"> Dataset </Typography>
                    <Autocomplete
                        className="re-form-autocomplete"
                        classes={{ input: classes.autoCompleteInp }}
                        size='small'
                        ListboxProps={{
                            className: "visual-dataset-list"
                        }}
                        // open={true}
                        onOpen={handleDataSetOpenStatus}
                        onClose={handleDataSetCloseStatus}
                        disablePortal={true}
                        disableClearable
                        popupIcon={<DropDownIcon />}
                        onChange={handleConfirmDataSetChange}
                        value={``}
                        options={dataSetList}
                        isOptionEqualToValue={(option) => option.dataSetName === selectedDataset.dataSetName}
                        renderInput={(params) => <TextField {...params} autoComplete="off" placeholder={selectedDataset ? selectedDataset?.label : null}
                            //  inputRef={input => input && input.focus()}
                             />}
                        renderOption={(props, obj) => {
                            return (
                            <ListItem {...props} value={obj.dataSetName} button
                                className={classes.searchFieldListItem + " re-form-autocomplete-item"} alignItems="flex-start"
                                disabled={selectedDataset.dataSetName === obj.dataSetName ? true : false}
                            >
                                <ListItemIcon sx={{ mt: '0px', mr: '0px' }}> <ParseSvgIcon component={VisualizeIcon} /> </ListItemIcon>
                                <Grid container >
                                <Grid item xs={12}>
                                    <Typography variant="body2" className="re-form-autocomplete-item-title"> {obj?.displayName} </Typography>
                                </Grid>
                                {/* <Grid item xs={12} className="text-sub-grid">
                                    <Typography variant="subtitle2" className="text-sub"> {obj.description ?? 'No description'} </Typography>
                                </Grid> */}
                                </Grid>
                            </ListItem>
                            )
                        }}
                        />
                </Box>
                <Box width="100%" height="100%" display="block" className="re-edit-settings-fields">
                    <Typography className="re-edit-settings-fields-label" variant="button" display="block" mt={2} > Field list </Typography>
                    <Box className="re-edit-settings-fields-wrapper">
                        <TextField className=" re-edit-settings-fields-input" type="search"  placeholder="Search" autoComplete="off"
                        onChange={handleSearchMeasure}
                        InputProps={{
                            endAdornment: (
                            <InputAdornment position="start">
                                <InputSearchIcon className="input_search_icon" sx={{ mr: '8px' }} />
                            </InputAdornment>
                            ),
                            classes: {
                            input: classes.formInput,
                            adornedEnd: classes.bgWhite + " form_input"
                            }
                        }} />
                    
                        <div className={`${classes.reportFieldList}` + ` re-edit-fieldlist`}>
                            {/* MEASURES */}
                            <ListSubheader className='re-edit-settings-fields-group-title' component="h2" id="nested-list-subheader">Measure</ListSubheader>
                            <List component="nav">
                                {selectedDataset?.measures?.filter(obj => obj.displayName.toLowerCase().includes(searchMeasure) && !obj.joinHiddenField).map((measure,index) => (
                                    <ListItem key={`${index}-${measure.name}`} button 
                                        className={`${query && query.measures && query.measures.indexOf(measure.title) > -1 ? 'visualize_list_text':''}  re-edit-settings-fields-item-title`} 
                                        onClick={() => clickMeasureListHandler(measure)}
                                        alignItems="flex-start">
                                        <ListItemIcon  className='re-edit-settings-fields-item-icon'>
                                            <FunctionsOutlinedIcon className="cm_dimension_icon" />
                                        </ListItemIcon>

                                        <Grid container className='report-visualise-field-listitem-content'>
                                            <Grid item xs={12}>
                                            <Typography className="re-edit-settings-fields-item-name"> {measure?.displayName}</Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                            <Typography className="re-edit-settings-fields-item-subtitle" variant="subtitle2" >{measure.comment ? `${measure?.description} (${measure.comment})`: `${(measure?.description ? measure?.description : 'No Description')}`} </Typography>
                                            </Grid>
                                        </Grid>

                                        <Button className={classes.fieldBtn + " no-hover height-100 py-0 more-icon"} 
                                            // onClick={(e) => onClickMoreMenu(e, measure)}
                                        >
                                            <FieldCloseIcon className={classes.searchFieldListMoreIcon + " text-icon re-edit-settings-fields-item-icon-close"} />
                                            <FieldTickIcon className={classes.searchFieldListMoreIcon + " text-icon re-edit-settings-fields-item-icon-tick"} />
                                        </Button>
                                    </ListItem>
                                ))}
                            </List>
                            
                            {/* DIMENSIONS */}
                            <ListSubheader className='re-edit-settings-fields-group-title' component="h2" id="nested-list-subheader">Dimension </ListSubheader>
                                <List component="nav">
                                {
                                //
                                selectedDataset?.dimensions?.filter(obj => obj.displayName.toLowerCase().includes(searchMeasure) && !obj.joinHiddenField).map((dimension, i) => (
                                    <ListItem key={i} button className={`${query && query.dimensions && query.dimensions.indexOf(dimension.title) > -1 ? 'visualize_list_text':''}  re-edit-settings-fields-item-title`} onClick={() => clickMeasureListHandler(dimension)}
                                    alignItems="flex-start">
                                    <ListItemIcon  className='re-edit-settings-fields-item-icon'>
                                        {dimension.type === "number" ? <Icon icon={hashFill} className="cm_measr_lbl num_icon" /> : dimension.type === "time" ? <DateRangeIcon className="cm_measr_lbl" /> : <LabelOutlinedIcon className="cm_measr_lbl" />}
                                    </ListItemIcon>

                                    <Grid container className='report-visualise-field-listitem-content'>
                                        <Grid item xs={12}>
                                        <Typography className="re-edit-settings-fields-item-name"> {dimension?.displayName}</Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                        <Typography className="re-edit-settings-fields-item-subtitle" variant="subtitle2" >{dimension.comment ? `${dimension?.description} (${dimension.comment})`: `${(dimension?.description ? dimension?.description : 'No Description')}`} </Typography>
                                        </Grid>
                                    </Grid>

                                    <Button className={classes.fieldBtn + " no-hover height-100 py-0 more-icon"} 
                                        // onClick={(e) => onClickMoreMenu(e, dimension)}
                                    >
                                        <FieldCloseIcon className={classes.searchFieldListMoreIcon + " text-icon re-edit-settings-fields-item-icon-close"} />
                                        <FieldTickIcon className={classes.searchFieldListMoreIcon + " text-icon re-edit-settings-fields-item-icon-tick"} />
                                    </Button>
                                    </ListItem>
                                ))}
                                </List>
                        </div>
                    </Box>
                </Box>
                <Box className="report-new-charts">
                    <ReportGraphTypes/>
                </Box>
            </Box>
        </div>
    </RootStyle>
}

export default memo(ReportVisualizeTab)